// src/taskpane/features/integrations/components/apiges/ApigesPanel.tsx

import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ApigesPanelProps {
  onBack: () => void;
}

const ApigesPanel: React.FC<ApigesPanelProps> = ({ onBack }) => {
  return (
    <div className="flex flex-col h-full bg-background">
      {/* Header */}
      <div className="px-6 py-4 border-b border-border flex items-center gap-3">
        <Button
          variant="ghost"
          size="icon"
          onClick={onBack}
          className="w-8 h-8"
        >
          <ArrowLeft className="w-4 h-4" />
        </Button>
        <img 
          src="assets/logos/apiges-logo.png" 
          alt="APIGES logo"
          className="h-8 object-contain"
        />
        <div className="flex-1">
          <h2 className="text-xl font-semibold text-foreground">APIGES</h2>
          <p className="text-sm text-muted-foreground">APIGES integration</p>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="text-center">
          <p className="text-muted-foreground">Coming soon...</p>
        </div>
      </div>
    </div>
  );
};

export default ApigesPanel;

